import { Link } from 'react-router-dom';
import './NotFoundPage.css';
import { useTranslation } from '../i18n/LanguageContext.jsx';
import useDocumentMeta from '../lib/hooks/useDocumentMeta.js';
import useNoIndex from '../lib/hooks/useNoIndex.js';

/**
 * NotFoundPage — the catch-all for any URL that matches no route.
 *
 * Before this existed, an unmatched path rendered nothing: the router matched no
 * <Route>, so the routed area was simply empty. On most paths the visitor at
 * least kept the global nav and footer, but under the demo prefix the chrome was
 * suppressed too, leaving a completely blank page with no way out.
 *
 * noindex is deliberate. Azure Static Web Apps rewrites unknown paths to
 * /index.html and answers 200, so every 404 here is a SOFT 404 — a real HTTP 404
 * is not available to a static SPA. The robots tag is what stops search engines
 * treating these 200-status non-pages as indexable content.
 */
function NotFoundPage() {
  const { t } = useTranslation();

  useDocumentMeta(t('notFound.title'), t('notFound.message'));
  useNoIndex();

  return (
    <main className="notfound">
      <div className="notfound__card">
        <p className="notfound__code" aria-hidden="true">
          404
        </p>
        <h1 className="notfound__title">{t('notFound.title')}</h1>
        <p className="notfound__message">{t('notFound.message')}</p>
        <Link className="notfound__home" to="/">
          {t('notFound.backHome')}
        </Link>
      </div>
    </main>
  );
}

export default NotFoundPage;
